import style from "./Sorry.module.scss";

export const CitySorryContact = ({ description, lineBreak }: {description: any; lineBreak?: boolean | undefined}) => {

  return (
    <>
      {lineBreak ? (
        <>
          <p>{description}</p>
          <p>For information on other filing options:</p>
        </>
      ) : (
        <p>{`${description} For information on other filing options:`}</p>
      )}
      <ul>
        <li>Visit our website at <a href="https://cityofspringboro.com/268/Tax-Services" target="_blank" rel="noreferrer" className={style.sendLink} >www.cityofspringboro.com/268/Tax-Services</a></li>
        <li>Call us at <label className={style.labelBold}>{import.meta.env.VITE_APP_SAAS_CUSTOMER_PHONE}</label></li>
        <li>Email our <a href={`mailto:${import.meta.env.VITE_APP_SAAS_CUSTOMER_EMAIL}`} className={style.sendLink} >Tax Department</a></li>
      </ul>
    </>
  );
}
